import { useCallback } from 'react'
import Image from 'next/image'
import { FormikHelpers } from 'formik'

import Button from '@/components/Button'
import { State as modalState } from '@/components/Modal'
import { fetchAPI } from '@/lib/api'
import env from '@/lib/env'
import { logEvent } from '@/lib/gtm'

import { InnerModalStyle } from './style'

interface Hooks {
  handleContactSubmit: (
    value: ContactForm,
    helpers: FormikHelpers<ContactForm>,
  ) => void
}

function ModalContent() {
  return (
    <div css={InnerModalStyle}>
      <figure className="image-container">
        <Image
          src={`${env.BASE_PATH}/static/images/businessmen-working-with-laptop-smartphone-open-space-office-meeting-report-progress/businessmen-working-with-laptop-smartphone-open-space-office-meeting-report-progress.jpg`}
          alt="modal image"
          className="image-banner"
          layout="fill"
          objectFit="cover"
        />
      </figure>
      <section className="label-container">
        <h1>ขอบคุณสำหรับข้อมูล</h1>
        <p>เราจะทำการติดต่อกลับทางอีเมล</p>
      </section>
      <Button
        className="back-button"
        usePrimaryColor={true}
        isPrimary={true}
        onPress={() => modalState.hideModal()}
      >
        กลับสู่หน้าหลัก
      </Button>
    </div>
  )
}

export function useHooks(): Hooks {
  const handleContactSubmit = useCallback(
    async (data: RegistrationForm | ContactForm, { resetForm }) => {
      fetchAPI({
        url: env.APP_URL,
        prefix: `${env.BASE_PATH}/api`,
        path: '/contact',
        method: 'POST',
        data: data,
      })
        .then(() => {
          logEvent({
            category: 'Contact Us',
            action: 'Contact Us Form Success',
          })
        })
        .catch((error) => {
          if (error.response) {
            console.error(`${error.response.status}: ${error.response.data}`)
          } else if (typeof error === 'string' || typeof error === 'number') {
            console.error(`ERROR: ${error}`)
          }
        })
      modalState.showModal(<ModalContent />)
      resetForm()
    },
    [],
  )

  return { handleContactSubmit }
}
